export default {
    driver_performance_editCoachPanel_editCoachPanel_title: "Re-Assign Coach",
    driver_performance_editCoachPanel_title_card_p1: "Assign a coach to ",
    driver_performance_editCoachPanel_title_card_p2: " performance case",
    driver_performance_editCoachPanel_status: "Status",
    driver_performance_editCoachPanel_caseId: "Case ID",
    driver_performance_editCoachPanel_currentCoach: "Current Coach",
    driver_performance_editCoachPanel_unassignedCoach: "Unassigned Coach",
    driver_performance_editCoachPanel_selectCoach: "Select Coach",
    driver_performance_editCoachPanel_saveSuccessfully: "Coach was updated successfully",
    driver_performance_editCoachPanel_saveError: "An error occurred while reassigning the coach",
    driver_performance_editCoachPanel_save: "Save",
    driver_performance_editCoachPanel_cancel: "Cancel"
}